// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpcomingEventsRouteImport } from './routes/upcoming-events'
import { Route as TeamsRouteImport } from './routes/teams'
import { Route as TeamRankingsRouteImport } from './routes/team-rankings'
import { Route as RegionsRouteImport } from './routes/regions'
import { Route as RankingsRouteImport } from './routes/rankings'
import { Route as PlayersRouteImport } from './routes/players'
import { Route as HowItWorksRouteImport } from './routes/how-it-works'
import { Route as FactionRankingsRouteImport } from './routes/faction-rankings'
import { Route as EventsRouteImport } from './routes/events'
import { Route as BestPaintedRouteImport } from './routes/best-painted'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UpcomingEventIdRouteImport } from './routes/upcoming-event.$id'
import { Route as TeamIdRouteImport } from './routes/team.$id'
import { Route as PlayerIdRouteImport } from './routes/player.$id'
import { Route as EventIdRouteImport } from './routes/event.$id'

const UpcomingEventsRoute = UpcomingEventsRouteImport.update({
            id: '/upcoming-events',path: '/upcoming-events',getParentRoute: () => rootRouteImport
          })
const TeamsRoute = TeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => rootRouteImport
          })
const TeamRankingsRoute = TeamRankingsRouteImport.update({
            id: '/team-rankings',path: '/team-rankings',getParentRoute: () => rootRouteImport
          })
const RegionsRoute = RegionsRouteImport.update({
            id: '/regions',path: '/regions',getParentRoute: () => rootRouteImport
          })
const RankingsRoute = RankingsRouteImport.update({
            id: '/rankings',path: '/rankings',getParentRoute: () => rootRouteImport
          })
const PlayersRoute = PlayersRouteImport.update({
            id: '/players',path: '/players',getParentRoute: () => rootRouteImport
          })
const HowItWorksRoute = HowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => rootRouteImport
          })
const FactionRankingsRoute = FactionRankingsRouteImport.update({
            id: '/faction-rankings',path: '/faction-rankings',getParentRoute: () => rootRouteImport
          })
const EventsRoute = EventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => rootRouteImport
          })
const BestPaintedRoute = BestPaintedRouteImport.update({
            id: '/best-painted',path: '/best-painted',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UpcomingEventIdRoute = UpcomingEventIdRouteImport.update({
            id: '/upcoming-event/$id',path: '/upcoming-event/$id',getParentRoute: () => rootRouteImport
          })
const TeamIdRoute = TeamIdRouteImport.update({
            id: '/team/$id',path: '/team/$id',getParentRoute: () => rootRouteImport
          })
const PlayerIdRoute = PlayerIdRouteImport.update({
            id: '/player/$id',path: '/player/$id',getParentRoute: () => rootRouteImport
          })
const EventIdRoute = EventIdRouteImport.update({
            id: '/event/$id',path: '/event/$id',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,BestPaintedRoute: BestPaintedRoute,EventsRoute: EventsRoute,FactionRankingsRoute: FactionRankingsRoute,HowItWorksRoute: HowItWorksRoute,PlayersRoute: PlayersRoute,RankingsRoute: RankingsRoute,RegionsRoute: RegionsRoute,TeamRankingsRoute: TeamRankingsRoute,TeamsRoute: TeamsRoute,UpcomingEventsRoute: UpcomingEventsRoute,EventIdRoute: EventIdRoute,PlayerIdRoute: PlayerIdRoute,TeamIdRoute: TeamIdRoute,UpcomingEventIdRoute: UpcomingEventIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)